import { AttachmentsResponseInterface } from "../attachments/attachments-response.interface";

export interface UsersResponseInterface {
  id: string;
  email: string;
  role: UserRole;
  first_name: string | null;
  last_name: string | null;
  phone_number: string | null;
  status: UserStatus;
  position: UserPosition;
  created_at: string | null;
  updated_at: string | null;
  created_by: MiniUsersResponseInterface | null;
  updated_by: MiniUsersResponseInterface | null;
  attachment_signature: AttachmentsResponseInterface | null;
  attachment_avatar: AttachmentsResponseInterface | null;
}

export interface MiniUsersResponseInterface {
  id: string;
  email: string;
  role: UserRole;
  first_name: string | null;
  last_name: string | null;
  phone_number: string | null;
  position: UserPosition;
}

export enum UserStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  DELETED = "DELETED",
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export enum UserRole {
  MANAGER = 'MANAGER',
  MANAGEMENT = 'MANAGEMENT',
  SUPERVISOR = 'SUPERVISOR'
}

export enum UserPosition {
  INSIDE_SALES = 'Inside Sales',
  ACCOUNT_MANAGER = 'Account Manager',
  SENIOR_ACCOUNT_MANAGER = 'Senior Account Manager',
  BUSINESS_UNIT_MANAGER = 'Business Unit Manager',
  BUSINESS_DEVELOPMENT_MANAGER = 'Business Development Manager',
  HEAD_OF_SALES = 'Head of Sales',
  MANAGER_FOR_SALES_AND_OPERATION = 'Manager for Sales and Operation',
}